import { useEffect } from "react";

/**
 * Loader bridges the inline HTML pre-loader (in index.html) with React.
 * It renders nothing itself — the HTML pre-loader handles the visual.
 * When `show` becomes false (page fully loaded), it fades out and
 * removes the HTML pre-loader element.
 */
const Loader = ({ show }) => {
  useEffect(() => {
    const preLoader = document.getElementById("pre-loader");
    if (!preLoader) return;

    if (!show) {
      // Page fully loaded → fade out the HTML pre-loader
      preLoader.classList.add("hiding");
      const timer = setTimeout(() => preLoader.remove(), 900);
      return () => clearTimeout(timer);
    }
  }, [show]);

  // Renders nothing — the visual is handled by the inline HTML pre-loader
  return null;
};

export default Loader;
